import React, { useState, useEffect } from 'react';
import { Button, Form, Image, ProgressBar, Badge, Modal, FormText, Accordion, Card, Row, Col, Container } from 'react-bootstrap';
import { RenderHeader } from '../_components/Header';
import { NavbarSmart } from '../_components/NavbarSmart';

function About() {

  return (
    <>
      <RenderHeader />
      <NavbarSmart showLoggedIn='true' />
      <Container>
        <Row>
          <Col>
            <Card style={{border:"0px"}}>
              <Card.Title>
              <br/>
              About Me
              </Card.Title>
              <Card.Body>
                I created this site to hopefully allow tech folks to find new opportunities.  The site is free with no gaurantees as to completeness or timeliness.  How's that for a disclaimer.  Hope it helps you find your next role.  
                <br/>&nbsp;<br/>
                I don't share personal info and the service is always free.  
                <br/>&nbsp;<br/>
                -- Phil <br/>
                -- ( phil [.dot.] norris [.at.] outlook.com )
              {/* <Link to="/login">
                <Button to="/login">Login</Button>
              </Link>
              <Link to="/signup">
                <Button>Sign up</Button>
              </Link> */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default About;